import { render, staticRenderFns } from "../routeDetailModal/routeDetailDeliveryForm.html?vue&type=template&id=48d9d8c0&scoped=true&external"
import script from "../routeDetailModal/routeDetailDeliveryForm.js?vue&type=script&lang=js&external"
export * from "../routeDetailModal/routeDetailDeliveryForm.js?vue&type=script&lang=js&external"
import style0 from "../routeDetailModal/routeDetailDeliveryForm.css?vue&type=style&index=0&id=48d9d8c0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d9d8c0",
  null
  
)

export default component.exports